import {connect} from 'react-redux'

const isMarkedSportsmen = (state) => (id) => {
    return state.markedSportsmen.sportsmen.includes(id)
};
const isMarkedTeam = (state) => (id) => {
    return state.markedSportsmen.teams.includes(id)
};

const isMarkedMatchSide = (state) => ({type, id}) => {
    switch (type) {
        case 'match-side--sportsmen':
            return isMarkedSportsmen(state)(id);
        case 'match-side--team':
            return isMarkedTeam(state)(id);
        default:
            throw Error('Match Side not supported by MarkedSportsmen');

    }
};

export const withMarkedSportsmen = connect(() =>
    state => ({
        marked: state.markedSportsmen,
        isMarkedMatchSide: isMarkedMatchSide(state),
        isMarkedSportsmen: isMarkedSportsmen(state),
        isMarkedTeam: isMarkedTeam(state),
    })
);